import React from 'react';
import styled from 'styled-components';

import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

const Wrapper = styled.div`
  position: relative;
  max-width: 700px;
  width: 100%;
  margin: ${({ theme }) => theme.spacing(6, 'auto')};
`;

const Inner = styled.div`
  width: 100%;
  padding-top: 60%;
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  display: block;
  padding: 0px;
  width: 100%;
  height: 100%;
`;

const Case = () => (
  <SectionContainer>
    <SectionTitle title="佐賀県の連携事例" subtitle="CASE" />
    <Wrapper>
      <Inner>
        <Iframe
          src="https://www.youtube.com/embed/tU2QstNkps8"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </Inner>
    </Wrapper>
  </SectionContainer>
);

export default Case;
